import {BasicSelect,MultiSelect} from 'vue-search-select';
import createodapincode from './../Createodapincode';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import AdminSettingsService from './../../../services/adminsettings.service';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';
import MasterService from './../../../../masterdata/services/masterdata.service';
export default {
  name: 'OdaPincode',
  components: {
    Pagination,
    BasicSelect,
    createodapincode,
    Loader,
    CustomExpandableTable
  },
  data: function() {
    return {
       servicepincode: '',
      tableArr: [],
      // zoneListArr: [],
       UpdateOdapincode: '',
       selectedODAObj: '',
       type:'ODA_PINCODE',
       isLoading:false,
       Loader:false,
       showOdapincode: false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: [ 'Service Pincode', 'Pincode Type', 'Region','State','City','Pincode KMS Branch','Status','Action'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: []
    }
  },
  computed: {

  },
  mounted() {
  this.getODAPincodeList();
  },
  methods: {
    showODApincode() {
      this.selectedODAObj = [];
      this.showOdapincode = true;
    },
    callParent() {
        this.showOdapincode = false;
        this.selectedODAObj = null;
        this.currentPage = 1;
        this.offset = 0;
        this.getODAPincodeList();
      },
      searchODAPincode(){
        this.currentPage = 1;
        this.offset = 0;
        this.getODAPincodeList();
      },
      async getODAPincodeList() {
        this.isLoading = true
        try {
          let inputPayload = {
            "offset": this.offset,
            "limit": this.pageLimit,
          }
          if (this.servicepincode != '') {
            inputPayload.servicepincode = this.servicepincode.trim();
          }
          let result = await AdminSettingsService.getODApincodeDetails(inputPayload);
          this.isLoading = false;
          this.totalCount = result.data.data.count;
            this.tableArr = result.data.data.rows;
            this.tableItems = result.data.data.rows.map((el)=>{
              return {
                'id':el.id,
                'Service Pincode':el.servicepincode,
                'Pincode Type': el.pincodetype,
                'Region': el.region,
                'State': el.state,
                'City': el.city,
                'Pincode KMS Branch': el.pincodekmsfrombranch,
                'Status': el.status,
                'Action': 'Need To Check1'
              }
            })
          if (this.totalCount < this.pageLimit) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
          }
        } catch (err) {
          this.ZoneLoading = false;
          console.log(err);
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
        this.getODAPincodeList()
      },
      clearForm() {
        this.currentPage =  1,
        this.servicepincode = '';
        this.getODAPincodeList();
        document.getElementById("servicepincode").value= '';
        this.$validator.reset();
      },
      getCustomTableEvent(event) {
        if(event.actionType=="active"){
          this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.activeAction(event);
         }).catch((err)=>{
           console.log(err)
         });
       }else if(event.actionType=="inactive"){
          this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.activeAction(event);
         }).catch((err)=>{
           console.log(err)
         })
        }
        if (event.actionType == "edit") {
          this.UpdateOdapincode = this.tableArr.filter(function (Items) {
            return Items.id == event.id;
          });
          this.selectedODAObj = this.UpdateOdapincode;
          this.showOdapincode = true;
        }
      },
      async activeAction(data){
        try {
          this.isLoading = true;
          var item = this.tableArr.find(item => item.id === data.id);
          var isactivestatus = item.status == 0 ? 1 : 0
          let inputPayload = {
            "id": data.id,
            "type": this.type,
            "status": isactivestatus
          }
          let result = await MasterService.changeStatus(inputPayload)
          if(result.data.code == 200){
            if(result.data.data[0].status == 0){
            this.$alert("ODA Pincode Activated Successfully!!", "ODA Pincode", "success");
          }else{
            this.$alert("ODA Pincode Inactivated Successfully!!", "ODA Pincode", "success");
           }
            this.getODAPincodeList();
            this.isLoading = false;
          }
        } catch(err){
          console.log(err);
        }
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/odapincodemaster/odapincodListing/odapincodListing.component.js